import { logger } from './logger'
import { fetchFromService } from '../utils/fetch'
import { merge } from 'lodash-es'
import { type ServiceEnvironment } from './get-url'

/**
 *
 * @param settings
 */
export async function loadSettingsFromConfig<T extends { env?: ServiceEnvironment, configId?: string | undefined, config?: string | undefined }> (settings?: T): Promise<T> {
  let data
  const id = settings?.configId ?? settings?.config

  if (!(id === null || id === undefined)) {
    data = await fetchFromService({
      service: 'content',
      path: `/embed/by-id/${id}`,
      env: settings?.env
    })

    logger.debug('Loaded settings from config: ', data)
  }
  return merge({}, settings, data)
}
